import * as CryptoJS from "crypto-js";

let _security = undefined;

function normalizeInput(input) {
  const output = input
    .toLowerCase()
    .replace(/[^\x00-\x7F]/g, "")
    .replace("[^wds]", "")
    .replace(/\s+/g, " ")
    .trim();

  console.log("normalizeInput", output);

  return output;
}

export function initAccounts(security) {
  _security = security;
}

export function logIn(event) {
  // We don't want anything else going on.
  const form = document.getElementById("login");
  const redirect = form.getAttribute("data-redirect");
  const userBox = document.getElementById("login-user");
  const passBox = document.getElementById("login-pass");
  const message = document.getElementById("login-message");

  event.preventDefault();

  // Clear out the old message.
  message.innerHTML = "";

  // Get the text for the two fields and make sure they are populated.
  const user = normalizeInput(userBox.value);
  const pass = normalizeInput(passBox.value);

  const icon =
    "<i class='fa-sharp fa-solid fa-circle-exclamation float-left'></i>";

  if (!user) {
    userBox.focus();
    message.innerHTML = `<div>${icon} A user name and password are required.</div>`;
    return;
  }

  if (!pass) {
    passBox.focus();
    message.innerHTML = `<div>${icon} A user name and password are required.</div>`;
    return;
  }

  // Use the security data and hash the user name and password.
  const initial = `${user}:${pass}`;
  let hashed = CryptoJS.SHA512(initial);

  console.log(_security);
  console.log("logIn", "hashing password", initial);

  for (let i = 0; i < _security.rounds; i++) {
    var hasher = CryptoJS.algo.SHA512.create();

    hasher.update(hashed.toString());
    hasher.update(_security.seed);

    hashed = hasher.finalize();

    console.log("logIn", i, hashed.toString());
  }

  hashed = hashed.toString();

  // Retrieve the results with a simple GET call. We handle security by
  // using fail2ban in the back end to avoid walking through all the
  // possible 16^28 possible options.
  const url = `/logins/${hashed}.json`;

  console.log("requesting", url);

  fetch(url)
    .then((response) => response.json())
    .then((data) => (localStorage.security = JSON.stringify(data)))
    .then((_) => {
      if (redirect) {
        window.location.href = redirect;
      } else {
        window.location.reload();
      }
    })
    .catch((_) => {
      message.innerHTML = `<div>${icon} Unable to log in, please try again.</div>`;
      passBox.focus();
    });
}
